var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 content",staticStyle:{"padding-top":"0"}},[_c('div',{staticClass:"content__columns shadow-lg mt-n2"},[_c('router-view')],1),_c('custom-alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }